// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ir-1";
export var quotedThread = "_ir-0";